import CartMenu from "./components/CartMenu.vue"
import CrossSellingModal from "./components/CrosSellingModal.vue"
import EshopSidebarMenu from "./components/EshopSidebarMenu.vue"
import MobileMenu from "./components/MobileMenu"
export default [
    {
        component: CartMenu,
        element: 'CartMenu'
    },
    {
        component: CartMenu,
        element: 'CartMenuMobile'
    },
    {
        component: CrossSellingModal,
        element: 'CrosSellingModal'
    }
    ,
    {
        component: EshopSidebarMenu,
        element: 'EshopSidebarMenu'
    }
    ,
    {
        component: MobileMenu,
        element: 'MobileMenu'
    }
];